import(/* webpackMode: "eager" */ "/vercel/path0/src/app/cebinov/page.tsx");
